<template>
  <v-dialog
    v-model="dialog"
    width="460"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="addIcon"
        color="secondary"
        fab
        x-small
        v-bind="attrs"
        v-on="on"
        class="ml-2"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        v-else
        color="secondary"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card
      :loading="isProcessing"
      :disabled="isProcessing"
      rounded="lg"
      class="px-10 py-3"
    >
      <v-card-title class="pl-0">
        Edit Metal Prices
      </v-card-title>
      <v-form
        v-model="formValid"
        ref="form"
      >
        <v-text-field
          label="Platinum Price"
          v-model="platinumPrice"
          outlined
          dense
          required
          type="number"
          :min="0"
          :step="1"
          :rules="metalPriceRules"
          suffix="USD"
        ></v-text-field>
        <v-text-field
          label="Palladium Price"
          v-model="palladiumPrice"
          outlined
          dense
          required
          type="number"
          :min="0"
          :step="1"
          :rules="metalPriceRules"
          suffix="USD"
        ></v-text-field>
        <v-text-field
          label="Rhodium Price"
          v-model="rhodiumPrice"
          outlined
          dense
          required
          type="number"
          :min="0"
          :step="1"
          :rules="metalPriceRules"
          suffix="USD"
        ></v-text-field>
      </v-form>
      <error-alert
        :message.sync="requestError"
        :validationMessages="requestValidationErrors"
      ></error-alert>
      <v-row class="mt-0">
        <v-col>
          <v-btn
            block
            color="success"
            @click="switchToLiveMetalPrices"
          >Switch to Live</v-btn>
        </v-col>
        <v-col>
          <v-btn
            block
            color="error"
            @click="validateAndLockPrices"
          >Lock Prices</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "@/store/modules/preciousMetals";
import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";

export default {
  props: {
    addIcon: Boolean,
  },
  data() {
    return {
      platinumPrice: null,
      palladiumPrice: null,
      rhodiumPrice: null,
      dialog: false,
      metalPriceRules: [
        (v) => !!v || "required",
        (v) => (Number.isInteger(Number(v)) && v >= 0) || "Price must be positive number",
      ],
      formValid: false,
      isProcessing: false,
      requestError: null,
      requestValidationErrors: null,
    };
  },

  computed: {
    ...mapState({
      metals: (state) => state.data,
    }),
  },

  watch: {
    dialog: function (newDialog, oldDialog) {
      // whenever dialog opens lets replace the form values with the vuex metal prices
      if (newDialog === true) {
        this.updateLocalMetalsState();
      }
    },
  },

  methods: {
    ...mapMutations({
      METALS_FETCH_SUCCESS: "FETCH_SUCCESS",
    }),
    updateLocalMetalsState() {
      if (this.metals && this.metals.platinum) {
        this.platinumPrice = this.metals.platinum;
      }
      if (this.metals && this.metals.palladium) {
        this.palladiumPrice = this.metals.palladium;
      }
      if (this.metals && this.metals.rhodium) {
        this.rhodiumPrice = this.metals.rhodium;
      }
    },
    validateAndLockPrices() {
      this.$refs.form.validate();
      if (this.formValid) {
        this.lockMetalPrices();
      }
    },
    async lockMetalPrices() {
      // lets send the new data to the server and then update the vuex metals state also
      try {
        const data = extractDataAxios(
          await window.axios.post("/api/edit-metal-prices", {
            platinum: this.platinumPrice,
            palladium: this.palladiumPrice,
            rhodium: this.rhodiumPrice,
          })
        );
        if (data) {
          this.METALS_FETCH_SUCCESS(data);
          this.dialog = false;
        }
      } catch (e) {
        console.error(e);
        this.requestError = "Locking Metal Prices failed. Error: " + extractErrorMessageAxios(e);
        this.requestValidationErrors = extractValidationErrorsAxios(e);
      }
    },
    async switchToLiveMetalPrices() {
      // lets send the new data to the server and then update the vuex metals state also
      try {
        const data = extractDataAxios(await window.axios.get("/api/switch-to-live-metal-prices"));
        if (data) {
          this.METALS_FETCH_SUCCESS(data);
          this.dialog = false;
        }
      } catch (e) {
        console.error(e);
        this.requestError = "Switch to live Metal Prices failed. Error: " + extractErrorMessageAxios(e);
      }
    },
  },
};
</script>